import { getUtilityClasses } from "../styles";
export const menuButtonClasses = getUtilityClasses("MenuButton", ["root", "icon"]);
